import React from "react";
import { PayPalButtons, PayPalScriptProvider } from "@paypal/react-paypal-js";
import axios from "axios";
import UserDB from "@/utils/userdb";
import { useRouter } from "next/navigation";

export default function PaypalButton() {
  const router = useRouter();
  const styles = {
    shape: "rect",
    layout: "vertical",
  };

  const initialOptions = {
    clientId:
      process.env.MODE === "PROD"
        ? process.env.NEXT_PUBLIC_PAYPAL_CLIENT_ID
        : process.env.NEXT_PUBLIC_PAYPAL_TEST_CLIENT_ID,
  };

  const onCreateOrder = async () => {
    const user = UserDB.getUser();
    if (!user || !user._id) {
      router.push("/signin?path=%Fpricing");
      return;
    }
    try {
      const response = await axios.post(
        `${process.env.SERVER_BASE_URL}/paypal-payment/createOrder`,
        { userId: user._id },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      // console.log(response);
      return response.data.orderId;
    } catch (error) {
      console.log(error);
    }
  };

  const onError = (err) => {
    // navigate('/cancel-payment')
    // console.log(err)
    router.push("/pricing/paypal-payment-acknowledgement?status=cancel");
  };

  const onApprove = async (data) => {
    const user = UserDB.getUser();
    if (!user || !user._id) {
      router.push("/signin?path=%Fpricing");
      return;
    }

    try {
      // console.log("comes on onapporve");
      // console.log(data, "dataa from aprove");
      if (!data?.orderID) throw new Error("Invalid order ID.");
      const response = await axios.get(
        `${process.env.SERVER_BASE_URL}/paypal-payment/capturepayment/${data.orderID}?userId=${user._id}`
      );
      // console.log(response);
      const result = response;
      // complete payment route
      //   navigate('/complete-payment')
      if (response.data.status == "success") {
        router.push("/pricing/paypal-payment-acknowledgement?status=success");
      }
    } catch (error) {
      //   navigate("/cancel-payment")
      // console.log(error)
      router.push("/pricing/paypal-payment-acknowledgement?status=cancel");
    }
  };

  const onCancel = async (data) => {
    router.push("/pricing/paypal-payment-acknowledgement?status=cancel");
  };

  return (
    <div>
      <PayPalScriptProvider options={initialOptions}>
        <PayPalButtons
          style={styles}
          createOrder={onCreateOrder}
          onApprove={onApprove}
          onError={onError}
          onCancel={onCancel}
          fundingSource="paypal"
        />
      </PayPalScriptProvider>
    </div>
  );
}
